import { Icon } from '@sb1/ffe-icons-react';
import rocket_launch from '@sb1/ffe-icons/icons/open/300/md/rocket_launch.svg';
import ThemeContainer from '../theme-container/ThemeContainer';
import styles from './social-proof.module.less';

const SocialProof = ({ text }) => (
    <ThemeContainer className={styles.container}>
        <Icon className={styles.icon} fileUrl={rocket_launch} />
        <span className={styles.text}>{text}</span>
    </ThemeContainer>
);

export default SocialProof;
